import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    body {
      margin: 0; line-height: normal;
    }
:root {

/* fonts */
--h1: 'Petit Serif trial';
--body-1: Mukta;
--italics: Cormorant;

/* font sizes */
--header-tabs-size: 18px;
--font-size-sm: 14px;
--h1-size: 70px;
--body-1-size: 28px;
--italics-size: 40px;

/* Colors */
--color-sienna: #7e573e;
--text: #333;

}
`;
